import { PaletteMode } from '@mui/material';
import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';

// Common theme settings
const commonThemeSettings: Partial<ThemeOptions> = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: 'none',
          borderRadius: 8,
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 12,
          boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)',
        }),
      },
    },
  },
};

// Light theme palette
const lightPalette = {
  mode: 'light' as PaletteMode,
  primary: {
    main: '#6a1b9a',
    light: '#9c4dcc',
    dark: '#38006b',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#f50057',
    light: '#ff5983',
    dark: '#bb002f',
    contrastText: '#ffffff',
  },
  background: {
    default: '#f8f9fa',
    paper: '#ffffff',
  },
  text: {
    primary: '#212121',
    secondary: '#757575',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
};

// Dark theme palette
const darkPalette = {
  mode: 'dark' as PaletteMode,
  primary: {
    main: '#bb86fc',
    light: '#eec4ff',
    dark: '#8858c8',
    contrastText: '#000000',
  },
  secondary: {
    main: '#ff79b0',
    light: '#ffaae3',
    dark: '#c94f7c',
    contrastText: '#000000',
  },
  background: {
    default: '#121212',
    paper: '#1e1e1e',
  },
  text: {
    primary: '#e0e0e0',
    secondary: '#b0b0b0',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
};

// Create theme based on mode
export const getTheme = (mode: PaletteMode): Theme => {
  return createTheme({
    palette: mode === 'light' ? lightPalette : darkPalette,
    ...commonThemeSettings,
  } as ThemeOptions);
}; 